import { render, staticRenderFns } from "./permissionStat.vue?vue&type=template&id=0a212c62&scoped=true"
import script from "./permissionStat.vue?vue&type=script&lang=js"
export * from "./permissionStat.vue?vue&type=script&lang=js"
import style0 from "./permissionStat.vue?vue&type=style&index=0&id=0a212c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a212c62",
  null
  
)

export default component.exports